// components/PublicRoute.jsx
import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import { CircularProgress, Box } from "@mui/material";

const PublicRoute = ({ children, restricted = false }) => {
  const location = useLocation();
  const { isLoggedIn } = useSelector((state) => state.globalData);
  
  // Check if user is authenticated
  const isAuthenticated = isLoggedIn || localStorage.getItem("user-token");

  // If route is restricted (like login/signup) and user is authenticated, redirect to dashboard
  if (restricted && isAuthenticated) {
    // Get the intended destination from location state, or default to dashboard
    const from = location.state?.from?.pathname || "/dashboard";
    return <Navigate to={from} replace />;
  }

  return children;
};

export default PublicRoute;
